import { useRef } from 'react';
import styled, { css } from 'styled-components';

import { Flex } from '@/components/base';
import Checkbox from '@/components/Checkbox/Checkbox';
import Typo from '@/components/Typography/Typo';
import { getAlphaColor } from '@/styles/colors/color.utils';

type Props = {
  name: string;
  selected: boolean;
  share: string;
  width: string;
  onClick: () => void;
};

const BarItemStyle = (props: Props) => {
  const ref = useRef(null);
  // const [show, setShow] = useState(false);
  // const onIntersect = (entries: IntersectionObserverEntry[]) => {
  //   entries.forEach((entry) => {
  //     setShow(entry.isIntersecting);
  //   });
  // };

  // useIntersectionObserver({
  //   target: ref,
  //   threshold: 0.1,
  //   onIntersect,
  // });

  const barLeftOffset = 34;

  return (
    <Style onClick={props.onClick} ref={ref} selected={props.selected}>
      <div
        style={{
          width: `calc(${props.width}% - ${barLeftOffset}px)`,
          left: barLeftOffset,
        }}
        className="bar-style"
      />
      <Flex g={24} className="content" a="center">
        <Checkbox checked={props.selected} />
        <Flex a="center" g={6}>
          <Typo type="label2" weight="sb">
            {props.name}
          </Typo>
          <Typo type="label2" weight="r">
            ({props.share}%)
          </Typo>
        </Flex>
      </Flex>
    </Style>
  );
};

type StyleProps = {
  selected: boolean;
};

const Style = styled(Flex)<StyleProps>`
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
  width: 100%;
  height: 40px;
  align-items: center;
  overflow: visible;

  .content {
    position: absolute;
    z-index: 1;
  }
  .bar-style {
    position: absolute;
    height: 100%;
    border-radius: 40px;
    background-color: ${(props) => props.theme.colors.gray250};
    border: 1px solid transparent;
    transition: all 0.2s;

    ${({ selected }) =>
      selected &&
      css`
        border-color: ${(props) => props.theme.colors.primary100};
        background-color: ${(props) => props.theme.colors.selected};
        &:hover {
          background-color: ${(props) => props.theme.colors.selected_hover};
        }
      `}
    animation: barGrow 0.5s;
    transform-origin: left;

    @keyframes barGrow {
      from {
        opacity: 0;
        transform: scaleX(0%);
      }
      to {
        opacity: 1;
        transform: scaleX(100%);
      }
    }
  }
  &:hover {
    .bar-style {
      background-color: ${(props) => props.theme.colors.hover};
      border-color: ${(props) =>
        getAlphaColor(props.theme.colors.primary100, 0.2)};
      ${({ selected }) =>
        selected &&
        css`
          border-color: ${(props) => props.theme.colors.primary100};
        `}
    }
  }
`;

export default BarItemStyle;
